// extracted by mini-css-extract-plugin
module.exports = {"container":"TextPersonSpecies_container__FaQva","text-anal":"TextPersonSpecies_text-anal__12p_G"};